import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  MenuItem,
  TextField,
} from "@mui/material";
import { ChangeEvent, MouseEvent, useCallback, useState } from "react";
import { IBranchHierarchyEmployeeDto } from "../../@types/branchRegion";
import { useBranchRegionContext } from "../../Context/BranchRegionContext";
import { StyledButton } from "../../Components/ui/CustomButton";
import {
  createBranchRegion,
  updateBranchRegion,
} from "../../Services/branchRegionService";

function BranchRegionDialog(props: any): JSX.Element {
  const branchRegionContext = useBranchRegionContext();
  const [error, setErrorText] = useState("");
  const employees = branchRegionContext?.employees;
  const open = branchRegionContext?.open ?? false;
  const branchRegionDto = branchRegionContext?.branchRegionDto;
  const selectedRegionId = branchRegionContext?.selectedRegionId;
  const selectedEmployeeId = branchRegionContext?.selectedEmployeeId;
  const selectedTitle = branchRegionContext?.selectedTitle;

  const handleSubmit = useCallback(
    async (event: MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      if (!selectedEmployeeId || !selectedTitle) {
        setErrorText("Please select a value");
      } else {
        setErrorText("");
        if (!branchRegionDto?.branchRegionId) {
          await createBranchRegion(branchRegionDto);
        } else {
          await updateBranchRegion(branchRegionDto);
        }
        branchRegionContext?.setOpen(false);
        await branchRegionContext?.load();
      }
    },
    [branchRegionDto, branchRegionContext, selectedEmployeeId, selectedTitle]
  );

  const handleDelete = useCallback(
    async (event: MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      branchRegionDto!.isActive = false;
      await updateBranchRegion(branchRegionDto);
      branchRegionContext?.setOpen(false);
      await branchRegionContext?.load();
    },
    [branchRegionDto, branchRegionContext, selectedEmployeeId, selectedTitle]
  );

  const handleTitleChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    branchRegionContext?.setSelectedTitle(event.target.value);
    branchRegionContext?.setBranchRegionDto({
      ...branchRegionDto,
      [name]: value,
    });
  };

    const handleEmployee = (
        event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        const { name, value } = event.target;
        branchRegionContext?.setSelectedEmployeeId(value);
        const selectedEmployee = employees?.find(
            (employee) => employee.employeeGuid === value
        );
        branchRegionContext?.setBranchRegionDto({
            ...branchRegionDto,
            [name]: value,
            managerEmployeeId: selectedEmployee?.employeeId ?? 0,
        });
    };

  return (
    <>
      <Dialog open={open} onClose={props.close}>
        <DialogTitle>Region - Save and Edit</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Box
              component="form"
              sx={{
                "& .MuiTextField-root": { m: 1, width: "25ch" },
              }}
              noValidate
              autoComplete="off"
            >
              <div>
                <TextField
                  disabled={true}
                  value={selectedRegionId}
                  id="outlined-basic"
                  name="branchRegionId"
                  placeholder="Branch Region Id"
                  label="Region Id"
                  variant="outlined"
                />
                <TextField
                  error={!selectedTitle}
                  helperText={!selectedTitle ? error : ""}
                  onChange={handleTitleChange}
                  value={selectedTitle}
                  id="outlined-basic"
                  required
                  name="title"
                  placeholder="Title"
                  label="Title"
                  variant="outlined"
                />
                <TextField
                  id="outlined-select-Employee"
                  select
                  required
                  name="managerEmployeeGuid"
                  label="Select Employee"
                  error={!selectedEmployeeId}
                  helperText={!selectedEmployeeId ? error : ""}
                  value={selectedEmployeeId}
                  onChange={handleEmployee}
                >
                  {employees &&
                    employees.map((employee: IBranchHierarchyEmployeeDto) => (
                      <MenuItem
                        key={employee.employeeGuid}
                        value={employee.employeeGuid}
                      >
                        {employee.name}
                      </MenuItem>
                    ))}
                </TextField>
              </div>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ display: "flex" }}>
            <StyledButton
              onClick={handleDelete}
              style={{ background: "#FF0000", marginRight: "auto" }}
            >
              Delete
            </StyledButton>
          <StyledButton onClick={handleSubmit}>Submit</StyledButton>
          <StyledButton onClick={props.close}>Cancel</StyledButton>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default BranchRegionDialog;
